import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import SpinnerComponent from "../../../@core/components/spinner/Fallback-spinner";
import repository from "../../../configs/axios/repository";
import { decrypt } from "../../../utility/helpers/encrypt";
// import Path_1150 from "../../../assets/images/pricing/Path_1150.png";
const SubscriptionCompleted = () => {
    const { token } = useParams();
    const urlParams = useMemo(() => {
        return JSON.parse(decrypt(token));
    }, [token]);

    const [subscription, setSubscription] = useState(null);
    const fetchPlan = async (subscriptionId) => {
        const result = await repository.findByEndPoint(
            `api/stripe/retrieveSubscription/${subscriptionId}`
        );

        if (result.data?.success) {
            setSubscription(result.data.data);
        }
    };
    useEffect(() => {
        fetchPlan(urlParams.subscriptionId);
    }, [urlParams.subscriptionId]);

    if (!subscription) {
        return <SpinnerComponent spiner={true} />;
    }

    return (
        <div className="mt-5">
            <Row className="justify-content-center mt-5">
                <Col lg={4}>
                    <div className="text-center mb-5 complitedHeader">
                        <h1 className="fw-bolder ">THANK YOU !</h1>
                    </div>

                    <Card>
                        <CardHeader className="planDiv">
                            <div className="text-center flex-grow-1">
                                <h4>
                                    {subscription?.plan?.metadata?.Interval ||
                                        ""}
                                </h4>
                                <h2 className="fw-bolder">
                                    ${subscription?.plan?.amount / 100}
                                </h2>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <h3 className="text-center planName">
                                {subscription?.plan?.product?.name || ""}
                            </h3>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default SubscriptionCompleted;
